import styled, { css } from "styled-components";
import { parseCSS } from "scripts/FunctionsBundle";
import Input from "./Input";

// ################################ INTERFACES & PROPS ################################
type _Base = import("@utils/ClassTypes")._Base;
// UsuariosForms => Rename all instances to use
type UsuariosFormsProps = {
  /** Variable a modificar con los campos. */
  _store: any;
  /** En caso de que el formulario sea de solo lectura. */
  _disabled?: boolean;
} & _Base;

// ################################ RENDERING COMPONENT ################################
const _UsuariosForms = (props: UsuariosFormsProps) => {
  // ------------------------------------------------------------------------------------ RETURN
  return (
    <>
      {/* ------------------------------------------ ID */}
      <div
        className="fieldset"
        style={{ padding: "0.5em 0.75em", marginTop: "0.5rem" }}
      >
        <Input
          _store={props._store}
          _store_var={"id"}
          _name={"id"}
          _label={"ID (autogenerado):"}
          _width={"s"}
          _disabled
        />
      </div>

      {/* ------------------------------------------------------------------------------------ INFO PRINCIPAL */}
      <fieldset>
        <legend>Datos del usuario</legend>

        {/* ------------------------------------------ USUARIO */}
        <Input
          _disabled={props._disabled}
          _store={props._store}
          _store_var={"user"}
          _name={"usuario"}
          _label={"Nombre de usuario:"}
          _width={"m"}
          _required={"*"}
          _placeholder={"Ej. Juan Pablo"}
          _tooltip={"Nombre de usuario con el que se va a acceder al programa."}
        />

        {/* ------------------------------------------ PASSWORD */}
        <Input
          _disabled={props._disabled}
          _store={props._store}
          _store_var={"pass"}
          _name={"password"}
          _label={"Contraseña:"}
          _width={"m"}
          _required={"*"}
          _tooltip={"Contraseña que usará el usuario para acceder."}
        />

        {/* ------------------------------------------ SACRAMENTOS */}
        <Input
          _disabled={props._disabled}
          _store={props._store}
          _store_var={"permiso_sacramentos"}
          _name={"permiso_sacramentos"}
          _label={"Acceso a sacramentos:"}
          _options={
            new Map([
              ["Ninguno", -1],
              ["Solo ver", 0],
              ["Ver y escribir", 1],
            ])
          }
          _tooltip={
            "Define los permisos que tendrá este usuario dentro de 'Sacramentos'."
          }
        />

        {/* ------------------------------------------ NICHOS */}
        <Input
          _disabled={props._disabled}
          _store={props._store}
          _store_var={"permiso_nichos"}
          _name={"permiso_nichos"}
          _label={"Acceso a nichos:"}
          _options={
            new Map([
              ["Ninguno", -1],
              ["Solo ver", 0],
              ["Ver y escribir", 1],
            ])
          }
          _tooltip={
            "Define los permisos que tendrá este usuario dentro de 'Nichos'."
          }
        />

        {/* ------------------------------------------ NOTAS */}
        <Input
          _disabled={props._disabled}
          _store={props._store}
          _store_var={"notas"}
          _name={"notas"}
          _label={"Notas adicionales:"}
          _tooltip={
            "Notas extras o consideraciones específicas para este registro."
          }
          _type={"textarea"}
        />
      </fieldset>
    </>
  );
};

// ################################ STYLES ################################
const UsuariosForms = styled(_UsuariosForms).attrs(
  (props: UsuariosFormsProps): UsuariosFormsProps => {
    return { ...props };
  }
)`
  ${(props) => css`
    ${parseCSS(props._style)}
  `}
`;

// ################################ EXPORTS ################################
export default UsuariosForms;
